import { useState, useEffect } from "react";

const RATES = { USD: 1, INR: 85 };

export function useCurrency() {
  const [currency, setCurrency] = useState("USD");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("resumeai_currency");
    if (stored && (stored === "USD" || stored === "INR")) {
      setCurrency(stored);
      setLoading(false);
      return;
    }
    const detect = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/", { signal: AbortSignal.timeout(3000) });
        const data = await res.json();
        if (data.country_code === "IN") {
          setCurrency("INR");
          localStorage.setItem("resumeai_currency", "INR");
        } else {
          setCurrency("USD");
          localStorage.setItem("resumeai_currency", "USD");
        }
      } catch {
        setCurrency("USD");
      } finally {
        setLoading(false);
      }
    };
    detect();
  }, []);

  const toggleCurrency = () => {
    const next = currency === "USD" ? "INR" : "USD";
    setCurrency(next);
    localStorage.setItem("resumeai_currency", next);
  };

  const formatPrice = (usdAmount) => {
    if (currency === "INR") {
      const inr = Math.round(usdAmount * RATES.INR);
      return `₹${inr.toLocaleString("en-IN")}`;
    }
    return `$${usdAmount}`;
  };

  return { currency, toggleCurrency, formatPrice, loading };
}
